export default __webpack_public_path__ + "static/media/icons8-logo-de-mysql.09f9d6f7.svg";